import { PieChart } from '@/common/dashboard/charts/PieChart';
import { Mode } from '@/common/entityFramework/enumerations/Mode';
import { useNavState } from '@/common/navState/NavStateContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { useEffect, useState } from 'react';

export const McdStlmntProgressChart = ({ selectedStates = [], selectedPeriod, selectedCtrts = [], selectedDueDate, isCld = false }) => {
  const { navigateTo } = useNavState();
  const rsrc = useRsrc();
  const [data, setData] = useState();

  useEffect(() => {
    if (!selectedPeriod?.id) return;

    const stateIds = selectedStates.map(state => state.id);
    const ctrtIds = selectedCtrts.map(ctrt => ctrt.id);
    const reqParam = {
      periodId: selectedPeriod?.id,
      stateIds,
      ctrtIds,
      startDate: selectedDueDate?.startDate,
      endDate: selectedDueDate?.endDate,
    };
    rsrc.data('sc', 'MCD_INV_STLMNT_PROGRESS_CHART_DATA_PLUGIN', reqParam).then(data => {
      setData(data);
    });
  }, [selectedStates, selectedPeriod, selectedCtrts, selectedDueDate]);

  const navigateToStlmntList = (dataPoint) => {
    const pymtIds = dataPoint.pymtIds;
    if (!pymtIds || pymtIds.length === 0) return;
    const expr = ExprUtils.setExpr('id', pymtIds);
    const navState = {
      mode: Mode.LIST,
      expr: expr,
    };
    navigateTo('sc/pymt/mcd', navState);
  };

  if (!data) return null;

  return (
    <PieChart
      data={data}
      onClick={navigateToStlmntList}
    />
  );
};
